import { useId, useState } from 'react';
import type { ReactNode } from 'react';

interface CollapsibleProps {
  /** 折叠标题（点击区域） */
  title: string;
  /** 收起状态下也要让人看到的一句话摘要（可选） */
  hint?: string;
  /** 默认是否展开；说明性内容一律默认收起 */
  defaultOpen?: boolean;
  /** 右侧小角标，如条目数 */
  badge?: string | number;
  className?: string;
  children: ReactNode;
}

/**
 * 通用折叠块：页面默认只展示标题+摘要，细节点击展开。
 * 用于把「口径声明 / 评分理由 / 阶段说明」这类长文案收起来，避免一屏全是字。
 */
export function Collapsible({
  title,
  hint,
  defaultOpen = false,
  badge,
  className,
  children,
}: CollapsibleProps) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();

  return (
    <section className={className === undefined ? 'collapsible' : `collapsible ${className}`}>
      <button
        type="button"
        className="collapsible-head"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="collapsible-caret" aria-hidden="true">
          ▸
        </span>
        <span className="collapsible-title">{title}</span>
        {badge !== undefined ? <span className="collapsible-badge">{badge}</span> : null}
        {hint !== undefined && !open ? <span className="collapsible-hint">{hint}</span> : null}
      </button>
      <div id={panelId} className="collapsible-panel" hidden={!open}>
        {children}
      </div>
    </section>
  );
}
